import { useParams } from 'react-router-dom';

import { AppIapPollPage } from '~/components/pages/AppIapPollPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const AppIapPollRoute: React.FC = () => {
  const { appId, iapPollId } = useParams();

  if (!appId) {
    return <Navigate to="/" />;
  }

  if (!iapPollId) {
    return <Navigate to={`/apps/${appId}`} />;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppIapPollPage appId={appId} iapPollId={iapPollId} />
    </DashboardTemplate>
  );
};
